import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getEntitiesWithProperties } from '..';
export const useGetEntitiesWithProperties = (bodyParams) => useQuery(['GetEntitiesWithProperties', bodyParams], () => trackPromise(getEntitiesWithProperties(bodyParams)), {
    cacheTime: 0,
    refetchOnWindowFocus: false,
    enabled: false,
});
